import { Component, OnInit } from '@angular/core';
import { AuthMethodService } from 'src/app/services/auth-method.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from './../../../models/Constants';

@Component({
  selector: 'app-pin-reminder',
  templateUrl: './pin-reminder.component.html',
  styleUrls: ['./pin-reminder.component.scss']
})
export class PinReminderComponent implements OnInit {
  fileName:string='pin-reminder.component.ts';
  PIN_REMINDER_USER_ERROR = Constants.PINRESET_MESSAGES.PIN_REMINDER_USER_ERROR;
  PINREMINDER=Constants.PINRESET_MESSAGES;
  constructor(public rootScope: RootScopeService, public logger: LogService,public authService:AuthMethodService) {

  }

  ngOnInit(): void {
   this.triggerGetPinReminderAddress();
  }


 
 
  openModelOverlay(){
    this.rootScope.showPinReminderConfirmationOverlay=true;
  }

  closeModelOverlay(type){
    if (type === 'Yes') {
      this.authService.sentPinResetMethod();
      this.rootScope.pinReminderErrorMsg = '';
      //logic for sending pin reminder
    }

    this.rootScope.showPinReminderConfirmationOverlay=false;
  }

  /**
   * Validates the panel state by checking if both success and error messages are absent.
   * 
   * @returns {boolean} Returns true if neither success nor error messages are present in rootScope, false otherwise.
   */
  panelValidation() {
    return (!this.rootScope.pinReminderSuccessMsg && !this.rootScope.pinReminderErrorMsg);
  }

  /**
   * Checks if an error message is present and determines the type of error to display.
   * CCR3-11988
   * @param type - Optional parameter to specify the error check type. When set to 'btn', 
   *               only checks for PIN_REMINDER_USER_ERROR. Otherwise, checks for both 
   *               PIN_REMINDER_USER_ERROR and NO_VALID_PINREMINDER_AVAILABLE errors.
   * @returns A boolean indicating whether the specified error condition is met.
   */
  errorMsg(type?:string) {
    if(type==='btn'){
      return (this.rootScope.pinReminderErrorMsg == Constants.PINRESET_MESSAGES.PIN_REMINDER_USER_ERROR);
    }
    else return (this.rootScope.pinReminderErrorMsg == Constants.PINRESET_MESSAGES.PIN_REMINDER_USER_ERROR||this.rootScope.pinReminderErrorMsg==Constants.PINRESET_MESSAGES.NO_VALID_PINREMINDER_AVAILABLE);
  }

  /**
   * Resets the PIN reminder state by clearing any error messages and triggering
   * the retrieval of the PIN reminder address.
   * CCR3-11988
   * This method clears the `pinReminderErrorMsg` from the root scope and initiates
   * the process to fetch the PIN reminder address information.
   * 
   * @returns {void}
   */
  resetPinReminder(){
    this.rootScope.pinReminderErrorMsg = '';
    this.triggerGetPinReminderAddress();
  }

  /**
   * Triggers the retrieval of the PIN reminder address for the active customer.
   * CCR3-11988
   * @remarks
   * This method checks if the PIN reminder address for the current active customer session
   * is already cached in `pinReminderAddress`. If not found, it initiates a request to
   * fetch the PIN reminder address via the auth service.
   * 
   * @returns void
   */
  triggerGetPinReminderAddress(){
   if (!this.rootScope.pinReminderAddress.has(this.rootScope.activeCustTab?.customerSessionId))
      this.authService.getPinReminderAddress();
  }

}
